import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { MerchantOrderStatusEnum } from '@/graphql/generatedTypes';
import type { OpsOrderDetail } from './types';
import i18n from '@/utils/i18n';
import { formatDateTimeLocalized } from '@/utils/formatter';
import { getStatusTranslation } from '../../utils/orderListFilters';

interface StatusHistorySheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  statusHistory: OpsOrderDetail['status_history'];
}

export function StatusHistorySheet({
  open,
  onOpenChange,
  statusHistory,
}: StatusHistorySheetProps) {
  const sorted = [...statusHistory].reverse();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>{i18n.t('MerchantOrder:statusHistory')}</SheetTitle>
        </SheetHeader>
        <div className="tw:divide-y tw:divide-border tw:overflow-y-auto tw:px-4">
          {sorted.map((entry, i) => (
            <div
              key={i}
              className="tw:flex tw:flex-col tw:gap-0.5 tw:py-4 tw:first:pt-0 tw:last:pb-8"
            >
              <span className="tw:font-semibold">
                {getStatusTranslation(entry.status)}
              </span>
              <span className="tw:text-sm">
                {formatDateTimeLocalized(
                  new Date(entry.timestamp),
                  i18n.language,
                )}
              </span>
              {entry.changed_by && (
                <span className="tw:text-muted-foreground tw:text-xs">
                  {entry.changed_by}
                </span>
              )}
            </div>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
